import { useState } from "react";
import Modal from "ui-kit/src/Modal";
import { RenameModal } from "../RenameModal";
import { BaseTable } from "./BaseTable";
import { RowActionButton, RowActionLink, rowActionIcons } from "./rowActions";

export function VideosInProcessingTable() {
	const [renameModal, setRenameModal] = useState<{ id?: number; name?: string; show: boolean }>({ show: false });

	return (
		<>
			<BaseTable
				preset="in-processing"
				actions={{
					id: "actions",
					key: "actions",
					label: "Actions",
					header: () => "Actions",
					cell: (value, row) => (
						<div className="actionsCell">
							<RowActionLink icon={rowActionIcons.status} label="Status" to={`/video-uploads/${row.id}/status`} />
							<RowActionButton
								icon={rowActionIcons.editName}
								label="Edit Name"
								onClick={() => setRenameModal({ show: true, id: row.id, name: row.name })}
							/>
						</div>
					),
				}}
			/>
			<Modal show={renameModal.show} onClose={() => setRenameModal({ show: false })} size="sm" title="Edit Name">
				{renameModal.show && (
					<RenameModal
						videoId={renameModal.id ?? 0}
						currentName={renameModal.name ?? ""}
						close={() => setRenameModal({ show: false })}
					/>
				)}
			</Modal>
		</>
	);
}
